










import React from "react";
import './PrivacyPolicy.css';
import useTranslation from '../hooks/useTranslation';

export default function PrivacyPolicy({ show, onAgree, onDecline }) {
  const { t } = useTranslation();
  
  if (!show) return null;
  
  return (
    <div className="privacy-overlay" role="dialog" aria-modal="true" aria-labelledby="privacy-title">
      <div className="privacy-container">
        <div className="privacy-header">
          <h2 id="privacy-title" className="privacy-title">{t('Privacy Policy')}</h2>
          <button
            type="button"
            className="privacy-close-btn"
            onClick={onDecline}
            aria-label={t('Close privacy policy')}
          >
            ×
          </button>
        </div>

        <div className="privacy-content">
          <div className="privacy-welcome">
            <p>
              <strong>{t('Welcome to Neurolonic!')}</strong><br/>
              {t('At Neurolonic, we are deeply committed to protecting your privacy and ensuring the security of your data. Please review the following privacy agreement before using our services.')}
            </p>
          </div>

          <div className="privacy-section">
            <h3>1. {t('Data Collection and Use')}</h3>
            <p>
              {t('Your audio recordings, as well as any resulting emotion and mental state analyses, will be securely stored on a private, encrypted cloud.')}<br/><br/>
              {t('These data are used exclusively for providing you with insights into your emotional and mental states.')}
            </p>
          </div>

          <div className="privacy-section">
            <h3>2. {t('Data Privacy')}</h3>
            <p>
              {t('We do not share or sell your data to any third parties. All personal and audio data remain strictly confidential.')}<br/><br/>
              {t('Only you have access to your data, and it will never be disclosed or accessible by any unauthorized personnel.')}
            </p>
          </div>

          <div className="privacy-section">
            <h3>3. {t('Professional Access After Launch')}</h3>
            <p>
              {t('After the official product launch, only certified professionals within Neurolonic may review data, solely for support and quality improvement purposes, and only with your explicit consent.')}
            </p>
          </div>

          <div className="privacy-section">
            <h3>4. {t('Security Measures')}</h3>
            <p>
              {t('We employ industry-standard encryption and privacy safeguards to protect your data. Our team continuously monitors and updates our security protocols to maintain the highest level of data protection.')}
            </p>
          </div>

          <div className="privacy-agreement">
            <p>
              {t('By signing up and using Neurolonic, you agree to this privacy policy and understand that your data will remain secure and confidential. Thank you for trusting Neurolonic with your journey.')}
            </p>
          </div>
        </div>

        <div className="privacy-footer">
          <button
            type="button"
            className="privacy-btn decline"
            onClick={onDecline}
          >
            {t('Decline')}
          </button>
          <button
            type="button"
            className="privacy-btn agree"
            onClick={onAgree}
          >
            {t('I Agree')}
          </button>
        </div>
      </div>
    </div>
  );
}
